(function () {
  'use strict';

  document.querySelectorAll('[data-section-type="product"]').forEach(function (root) {
    var form = root.querySelector('form[data-product-form]');
    if (!form) return;

    var idField = form.querySelector('[data-pp-variant-id]');
    var quantityField = form.querySelector('[data-pp-quantity]');
    if (!idField || !quantityField) return; // not a photo-printing buy box

    var addBtn = form.querySelector('[data-add-to-cart]');
    var addBtnText = addBtn ? addBtn.querySelector('[data-add-to-cart-text]') : null;
    var loader = addBtn ? addBtn.querySelector('[data-loader]') : null;
    var errorWrapper = form.querySelector('[data-error-message-wrapper]');
    var errorMessage = form.querySelector('[data-error-message]');
    var addedBanner = root.querySelector('[data-added-banner]');

    // ---- Notify Horizon's own native cart components (header cart-icon,
    // cart-items-component in the drawer/cart page) that the cart changed,
    // same mechanism used on the memory book page. ----
    function notifyNativeCartUpdate() {
      fetch('/cart.js')
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: 'photo-printing-add-to-cart',
              data: { itemCount: cart.item_count, source: 'photo-printing-add-to-cart' }
            }
          }));
        })
        .catch(function () {});
    }

    function setLoading(isLoading) {
      if (addBtn) addBtn.setAttribute('aria-disabled', isLoading ? 'true' : 'false');
      if (addBtnText) addBtnText.classList.toggle('hide', isLoading);
      if (loader) loader.classList.toggle('hide', !isLoading);
    }

    function showAdded() {
      if (!addedBanner) return;
      addedBanner.classList.remove('hide');
      window.clearTimeout(addedBanner._hideTimer);
      addedBanner._hideTimer = window.setTimeout(function () {
        addedBanner.classList.add('hide');
      }, 4000);
    }

    // ---- Reuse Horizon's own native add-to-cart animation (fly-to-cart +
    // checkmark-burst), same pattern as the memory book page. ----
    function animateAddToCart(button) {
      if (!button) return;

      if (window.customElements && customElements.get('fly-to-cart')) {
        var cartIcon = document.querySelector('.header-actions__cart-icon');
        var image = button.getAttribute('data-product-media');
        if (cartIcon && image) {
          var flyEl = document.createElement('fly-to-cart');
          flyEl.classList.add('fly-to-cart--main');
          flyEl.style.setProperty('background-image', 'url(' + image + ')');
          flyEl.style.setProperty('--start-opacity', '0');
          flyEl.source = button;
          flyEl.destination = cartIcon;
          document.body.appendChild(flyEl);
        }
      }

      button.dataset.added = 'true';
      window.clearTimeout(button._addedResetTimer);
      button._addedResetTimer = window.setTimeout(function () {
        button.removeAttribute('data-added');
      }, 800);
    }

    function showError(message) {
      if (errorWrapper && errorMessage) {
        errorMessage.textContent = message || 'Something went wrong. Please try again.';
        errorWrapper.classList.remove('hide');
      }
    }

    form.addEventListener(
      'submit',
      function (evt) {
        evt.preventDefault();
        if (errorWrapper) errorWrapper.classList.add('hide');
        if (addedBanner) addedBanner.classList.add('hide');

        var variantId = idField.value;
        var quantity = parseInt(quantityField.value, 10) || 1;
        if (!variantId) return;

        setLoading(true);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
        })
          .then(function (response) {
            return response.json().then(function (data) {
              if (!response.ok) throw data;
              return data;
            });
          })
          .then(function () {
            setLoading(false);
            showAdded();
            animateAddToCart(addBtn);
            notifyNativeCartUpdate();
          })
          .catch(function (err) {
            setLoading(false);
            showError(err && err.description);
          });
      },
      true // capture phase — this is the only submit handler for this form
    );
  });
})();
